import { AvatarProps } from "@material-ui/core";
import React from "react";
import { Root } from "./style";

export const Avatar: React.FC<AvatarProps> = (props) => {
  return <Root variant="square" imgProps={{ width: "10%" }} {...props} />;
};
